import { useMutation } from '@tanstack/vue-query';
import { logout } from '../api/endpoints';

const useKeycloakLogoutMutation = () => {
  return useMutation({
    async mutationFn() {
      const { data } = await logout({
        refreshToken: localStorage.getItem('refresh_token'),
      });

      return data;
    },
  });
};

export default useKeycloakLogoutMutation;
